export class ResolveRouteError extends Error {
  constructor(message: unknown, name = 'ResolveRouteError') {
    super(getErrorMessage(message))
    this.name = name
  }
}

export class ResolveLoadError extends ResolveRouteError {
  constructor(message: unknown) {
    super(message, 'ResolveLoadError')
  }
}

export class ResolveSkinError extends ResolveRouteError {
  constructor(message: unknown) {
    super(message, 'ResolveSkinError')
  }
}

export function getErrorMessage(error: unknown): string {
  if (typeof error === 'string') return error
  if (error instanceof Error) return error.message
  return String(error)
}
